import { cn } from "@/lib/utils/cn";

export type LoadingShape = "row" | "card";

export interface LoadingStateProps {
  /** Number of skeleton items to render. Defaults to 3. */
  count?: number;
  shape?: LoadingShape;
  className?: string;
}

/**
 * P6 — LoadingState.
 *
 * Per `component-api.md §2 P6`:
 *   - skeleton (row / card, count=N)
 *   - warm paper 底 + 280ms shimmer
 *   - 不允许 inline `animate-pulse` divs — use `.skeleton-shimmer` class.
 */
export function LoadingState({ count = 3, shape = "row", className }: LoadingStateProps) {
  return (
    <div
      data-component="LoadingState"
      data-shape={shape}
      aria-busy="true"
      aria-live="polite"
      className={cn("flex flex-col gap-2", className)}
    >
      {Array.from({ length: count }).map((_, idx) => (
        <div
          key={idx}
          className={cn(
            "skeleton-shimmer rounded-md",
            shape === "row" ? "h-12 w-full" : "h-28 w-full",
          )}
        />
      ))}
    </div>
  );
}
